import { render, staticRenderFns } from "./agentShop.vue?vue&type=template&id=1dcb3f6c&scoped=true&"
import script from "./agentShop.vue?vue&type=script&lang=js&"
export * from "./agentShop.vue?vue&type=script&lang=js&"
import style0 from "./agentShop.vue?vue&type=style&index=0&id=1dcb3f6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb3f6c",
  null
  
)

export default component.exports